import { deprecated } from "typesafe-actions";

import type { IMultiSearchResult, MultiSearchSource } from "@/shop/types/multiSearch";

const { createStandardAction } = deprecated;

// query tokenization

export const tokenizeQuery = createStandardAction("MULTI_SEARCH/TOKENIZE_QUERY").map((payload: string) => ({
  payload
}));

export const setSearchText = createStandardAction("MULTI_SEARCH/SET_SEARCH_TEXT").map((payload: string) => ({
  payload
}));

export const setTokenizedQuery = createStandardAction("MULTI_SEARCH/SET_TOKENIZED_QUERY").map((payload: string[]) => ({
  payload
}));

// submit / reset

export const submitSearch = createStandardAction("MULTI_SEARCH/SUBMIT")();

export const resetSearch = createStandardAction("MULTI_SEARCH/RESET")();

// fetch

export const fetchResults = createStandardAction("MULTI_SEARCH/FETCH").map((payload: null, meta: { collection: MultiSearchSource }) => ({ payload, meta }));

export const fetchStart = createStandardAction("MULTI_SEARCH/FETCH_START").map((payload: null, meta: { collection: MultiSearchSource }) => ({ payload, meta }));

export const fetchSuccess = createStandardAction("MULTI_SEARCH/FETCH_SUCCESS").map((payload: IMultiSearchResult, meta: { collection: MultiSearchSource }) => ({
  payload,
  meta
}));

export const fetchFail = createStandardAction("MULTI_SEARCH/FETCH_FAIL").map((payload: Error, meta: { collection: MultiSearchSource }) => ({
  payload,
  meta,
  error: true
}));

export const clearResults = createStandardAction("MULTI_SEARCH/CLEAR_RESULTS").map((payload: null, meta: { collection: MultiSearchSource }) => ({
  payload,
  meta
}));
